import * as React from 'react';
import { SelectItem } from 'vet-bones/utils/select';

import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import {
  DiagramModelCommitLayout,
  commitDiagramModel,
} from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { addProjectModelIdsToIri } from 'src/containers/ProjectDiagram/utils/projectModelIds';

export const useAddModelToClass = (iri?: string) => {
  const diagram = useDiagram();

  return React.useCallback(
    (item: SelectItem | null) => {
      if (!item || !diagram || !iri) {
        return;
      }

      commitDiagramModel(
        diagram,
        (model) => {
          addProjectModelIdsToIri(iri, [item.value])(model);

          Object.values(model.modelData.attributesByIri).forEach(
            (attributeData) => {
              const existingDomain = attributeData.domains[iri];
              if (existingDomain) {
                addProjectModelIdsToIri(attributeData.value, [item.value])(
                  model
                );
              }
            }
          );
        },
        { layout: DiagramModelCommitLayout.SKIP }
      );
    },
    [diagram, iri]
  );
};
